﻿import {$, $$, get, getCookie, hide, Key, remove, show} from "@/Utils"
import { tns, TinySliderSettings, TinySliderInfo } from "tiny-slider/src/tiny-slider"

export function openModal(modalButton: HTMLElement) {
  const target = modalButton.getAttribute("data-target");
  const buttonId = modalButton.getAttribute("id");
  const url = modalButton.getAttribute("data-url");
    if (url && url.length) {

    const iframe = $(`.video[data-url='${url}']`);
    $$(".video--active").forEach(e => e.classList.remove("video--active"));
    iframe.classList.add("video--active");
  }
    show($(".tns-inner"))
    openModalById(target, buttonId);
}

export function openModalById(modalId: string, buttonId?: string) {
    const modal = get(modalId);
    if (!modal){
        return false;
    }
    modal.classList.add("modal--active");
    document.body.classList.add("modal-open");
    if (buttonId) {
        modal.setAttribute("init-by", buttonId);
    }
    return true;
}

export function closeModal() {
    const modalActive = $(".modal--active")
    //do not allow closing cookie modal if cookies have not been accepted
    if (!modalActive || (modalActive.id === 'cookie-declaration-modal' && !getCookie("CookieConsent"))) return
    modalActive.querySelectorAll("[data-remove-on-close]").forEach(x => remove(x))
    hide(modalActive.querySelector(".tns-inner"))
    modalActive.classList.remove("modal--active")
    document.body.classList.remove("modal-open")


    const activeVideo = $(".video--active") as HTMLIFrameElement
    if (activeVideo) {
        const isYoutube = activeVideo.getAttribute("data-type") === "youtube"
        const pauseMessage = isYoutube
            ? {"event": "command", "func": "pauseVideo", "args": ""}
            : {"method": "pause"}

        activeVideo.contentWindow.postMessage(JSON.stringify(pauseMessage), "*")
    }
}

export function initModals() {
  const modalButtons = $$(".openModal");
  const closeButtons = $$(".close, .close-modal");

  modalButtons.forEach(elem => elem.addDataBoundEventListener("click", e => {
    const evTarget = e.currentTarget as HTMLElement;
    openModal(evTarget);
  }));

  // Function for close the Modal


  closeButtons.forEach(elem => elem.addDataBoundEventListener("click", closeModal));

  document.addEventListener("keyup", e => {
    if ($(".modal--active")) {
      if (e.key === Key.Escape) {
        closeModal();
      }
    }
  });

    if (window.popStateEventListenerBound != true) {
        window.addEventListener("popstate", () => {
            closeModal();
            window.popStateEventListenerBound = true;
        })
    }
}

function initImageModal() {
  if (!$(".big-slider") || !$(".small-slider__list")) return;

  function setImageHeight() {
    const imgs = $$(".big-slider .slider__image");
    const windowHeight = window.innerHeight;
    imgs.forEach((img) => { img.style.height = windowHeight - (windowHeight / 100 * 30) + "px"; });
  }

  const bigSlider = tns({
    container: ".big-slider",
    navContainer: ".small-slider__list",
    items: 1,
    navAsThumbnails: true,
    mouseDrag: true,
    autoplay: false,
    speed: 1000,    
    arrowKeys: true,
    loop: true,
    rewind: true,
      controlsContainer: ".big-slider__controls",
    responsive: {
        1216: {
            mouseDrag: false
        }
    },
    onInit: () => setImageHeight(),
    useLocalStorage: false
  } as TinySliderSettings);

  const visibleImageUrls = Array.from($$(".product-image__list li > img")).map(img => img.getAttribute("src"));
  const productImages = $$(".product-image__item");

  productImages.forEach(elem => elem.addEventListener("click", e => {
    const evTarget = e.target as Element;
    const thumbnail = $$(".product-image__img")[0] as Element;
    const thumbnailSrc = thumbnail.getAttribute("src");
    const targetSrc = evTarget.getAttribute("src");

    if (thumbnailSrc === targetSrc || targetSrc === null) return;
    thumbnail.setAttribute("src", targetSrc);

    const index = visibleImageUrls.indexOf(targetSrc);
    if (index >= 0) {
      bigSlider.goTo(index);
    }
  }));

  const smallSliderList = $(".small-slider__list") as Element;

  function clearStatus() {
    smallSliderList.querySelectorAll("li > img.slider__image--active").forEach(e => e.classList.remove("slider__image--active"));
  }

  const itemActive = (info: TinySliderInfo) => {
    clearStatus();

    const index = info.index <= info.slideCount
      ? info.index
      : 0;

    smallSliderList.querySelectorAll("li")[index].querySelector("img").classList.add("slider__image--active");
  };

  if (bigSlider) {
    bigSlider.events.on("indexChanged", info => itemActive(info));
  }

  const image = $(".big-slider .slider__image");
  const productModal = $(".modal-product");

  window.addEventListener("resize",
    () => {
      if (productModal.classList.contains("modal--active")) {
        const modalHeight = productModal.querySelector(".modal__content").clientHeight;
        const smallSliderHeight = $(".small-slider__list").clientHeight;
        image.style.height = modalHeight - smallSliderHeight - 150 + "px";
      }
    }
  );
}

export function initProductModals() {
  initModals();
  initImageModal();
}